import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { Box, Element } from 'react-bulma-components'
import EmployerRulesList from '../../components/employer-rules/list'
import { useEmployerRulesQuery } from '../../queries/employer-rules'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import EmployerRulesExplanation from '../../components/employer-rules/employer-rules-explanation'
import { AddResourceIcon } from '../../components/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { isAuthorizedFor } from '../../components/protected/protected'

/**
 * Component for managing employer financial rules
 */
const EmployerRulesSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const employerRulesQuery = useEmployerRulesQuery({ employer: employer._id })
  const navigate = useNavigate()
  const location = useLocation()

  const basePath = location.pathname.includes('/employers/')
    ? `/employers/${employer._id}`
    : '/settings'
  const isSuperAdmin = isAuthorizedFor(['superAdmin'])

  return (
    <>
      <SidebarContentTitle
        title="Règles employeur"
        help={<EmployerRulesExplanation textColor={'white'} />}
        onButtonClick={isSuperAdmin ? () => navigate(`${basePath}/employer-rules/new`) : undefined}
        addButtonLabel="Nouvelle règle"
        buttonDataTestId="new-employer-rule"
        ButtonIcon={AddResourceIcon}
      />
      <Box mb={1}>
        <EmployerRulesList employerRules={employerRulesQuery.data || []} employer={employer} />
      </Box>
      {!isSuperAdmin && (
        <Element renderAs="p" textColor="grey">
          Pour toute modification ou ajout de règles employeur, veuillez en faire la demande à
          support@teamtim.fr.
        </Element>
      )}
    </>
  )
}

export default EmployerRulesSettings
